import CallOutService from "../../../app/Modules/CallOut/resources/js/services/CallOutService";

export default {

    methods: {
        createExportFile(response, name) {
            const blob = new Blob([response.data], { type: response.data.type });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = name + this.getDateNow()
            link.click();
            URL.revokeObjectURL(link.href);
        },



    }
}
